/* Bactera - the landing page's own two behaviours.

   vc.js carries everything the VC sections share; these two belong to this
   page alone, so they travel with it rather than growing the shared file:

   1. the silent background clips, which only load while they are on screen
   2. a safety net under vc.js's reveal-on-scroll, for a block the browser
      never reports as having come into view

   Loaded by vc-head beside vc.js, once per section, so like vc.js it must
   set itself up exactly once. */
(function () {
  'use strict';
  if (window.__vcL8Loaded) return;
  window.__vcL8Loaded = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------ background clips --
     A clip only carries atmosphere, so it is never fetched until it is about
     to be seen, it is paused the moment it leaves the screen, and it fades in
     over its own poster once it has a frame to show. Anyone who asked their
     system for less motion keeps the poster and the clip is never loaded. */
  function bindVideo(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var vids = Array.prototype.slice.call(scope.querySelectorAll('video[data-vc-video]'));
    vids.forEach(function (v) {
      if (v.getAttribute('data-vc-bound')) return;
      v.setAttribute('data-vc-bound', '1');
      if (reduce) return;
      v.addEventListener('loadeddata', function () { v.classList.add('ready'); });
      function play() {
        if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
        var p = v.play();
        /* a phone that refuses to autoplay rejects here; the poster stays */
        if (p && p.catch) p.catch(function () {});
      }
      if (!('IntersectionObserver' in window)) { play(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (x) {
          if (x.isIntersecting) { play(); } else if (!v.paused) { v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      io.observe(v);
    });
  }

  /* ---------------------------------------------------------- reveal net --
     vc.js fades each block in as it comes into view. The page can grow under
     the reader while a picture loads, and a jump to an anchor can carry a
     block from below the fold to above the viewport without its intersection
     ever changing; either way the browser reports nothing and the block would
     stay invisible. On every scroll, whatever the viewport has already
     reached is revealed - adding the class vc.js would have added, so the two
     cannot disagree. */
  function bindRevealNet() {
    var ticking = false;
    function sweep() {
      ticking = false;
      var left = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.vc .rv:not(.in)'), function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight) {
          e.classList.add('in');
        } else {
          left++;
        }
      });
      if (!left) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sweep);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function bind(root) { bindVideo(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); bindRevealNet(); });
  } else {
    bind(document);
    bindRevealNet();
  }

  /* the theme editor re-renders single sections, so re-bind on those events */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:select', function (e) { bind(e.target); });
})();
